export default function FeedbackTab({ onClick }) {
  return (
    <div className="fixed right-0 top-1/2 z-50 -translate-y-1/2">
      <button
        onClick={onClick}
        className="bg-kf-red text-white text-xs font-semibold shadow-lg hover:opacity-90 transition-opacity duration-150 cursor-pointer select-none rounded-tr-md rounded-br-md"
        style={{ writingMode: "vertical-lr", transform: "rotate(180deg)", padding: "12px 8px" }}
        aria-label="Open feedback"
      >
        Feedback
      </button>
    </div>
  )
}
